import React from 'react';
import { useLang } from '../contexts/LanguageContext';
import { motion } from 'framer-motion';
import { HelpCircle } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';

export default function FAQSection() {
  const { t } = useLang();
  const items = t('faq.items') || [];

  return (
    <section id="faq" data-testid="faq-section" className="py-24 lg:py-32 bg-[#050505] relative">
      {/* Ambient */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-cyan/[0.03] rounded-full blur-[200px]" />
      
      <div className="max-w-3xl mx-auto px-6 lg:px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="inline-flex items-center gap-2 text-xs sm:text-sm font-bold tracking-[0.2em] uppercase text-cyan mb-4 bg-cyan/10 border border-cyan/20 rounded-full px-4 py-1.5 mx-auto">
            <HelpCircle className="w-3.5 h-3.5" />
            {t('faq.overline')}
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
            {t('faq.title')}
          </h2>
        </motion.div>

        <div className="bg-surface/50 backdrop-blur-sm border border-white/[0.06] rounded-3xl p-6 lg:p-10">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {items.map?.((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-white/[0.06] last:border-0"
                data-testid={`faq-accordion-item-${i}`}
              >
                <AccordionTrigger
                  className="py-5 lg:py-6 text-left text-base sm:text-lg font-semibold text-zinc-200 hover:text-neon hover:no-underline transition-colors [&[data-state=open]]:text-neon"
                  data-testid={`faq-trigger-${i}`}
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-zinc-400 text-sm sm:text-base font-light leading-relaxed pb-6">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
